import script from "./Album.vue?vue&type=script&lang=ts&setup=true"
export * from "./Album.vue?vue&type=script&lang=ts&setup=true"

import "./Album.vue?vue&type=style&index=0&id=cbadd77c&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cbadd77c"]])

export default __exports__